import { render } from "./workbench.vue?vue&type=template&id=39cf9692&scoped=true"
import script from "./workbench.vue?vue&type=script&lang=js"
export * from "./workbench.vue?vue&type=script&lang=js"

import "./workbench.vue?vue&type=style&index=0&id=39cf9692&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cf9692"]])

export default __exports__